import Aura from '@primeuix/themes/aura'

import { spdPreset } from './spd-preset'

export function resolveThemePreset() {
  return import.meta.env.VITE_CLIENT === 'spd' ? spdPreset : Aura
}

export const primeVueThemeOptions = {
  darkModeSelector: false as const,
}
